import { InjectionToken } from '@angular/core';

import { DuplicateRequestReporter } from '../contracts/duplicate-request-reporter.interface';

export const DUPLICATE_REQUEST_REPORTER = new InjectionToken<DuplicateRequestReporter>('DUPLICATE_REQUEST_REPORTER');
